'use client'

import { Button, useDevice } from '@lune-fe/lune-ui-lib'
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight'
import { FC } from 'react'

import BlueBox from '@/components/BlueBox'

const RequestDemoGreen: FC = () => {
    const { smScreen } = useDevice()

    return (
        <BlueBox
            customBackgroundImg={'/images/blue-box/green-box-gradient-desktop.png'}
            text={'Join the leading Scope 3 platform for carbon visibility & compliance, today'}
            rightSide={
                <Button
                    href="/request-a-demo"
                    sx={{ width: smScreen ? '100%' : 'auto' }}
                    variant={'contained'}
                    leftIcon={<ArrowCircleRightIcon />}
                >
                    Request a demo
                </Button>
            }
        />
    )
}

export default RequestDemoGreen
